import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config/fbConfig';
import React, { useEffect, useState } from 'react';
import Logo from '../images/school_logo.png';

const ArchiveClasses = () => {
  const { sectionId, sessionId, termId } = useParams();
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const q = query(
          collection(db, 'classes'),
          where('section', '==', sectionId),
          where('session', '==', sessionId),
          where('term', '==', termId)
        );
        const snap = await getDocs(q);
        setClasses(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (error) {
        console.error('Error fetching classes:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClasses();
  }, [sectionId, sessionId, termId]);

  return (
    <>
      <div className="top-elements row align-center space-between">
        <button onClick={() => navigate(-1)} className="back-link back-link1">
          <i className="fa-solid fa-arrow-left size3"></i>
        </button>
        <div className="column align-center justify-center">
          <img src={Logo} className="middle-logo" alt="logo" />
        </div>
        <RouterLink to="#" className="home-link" onClick={() => window.location.reload()}>
          <i className="fa-solid fa-rotate-right size4"></i>
        </RouterLink>
      </div>

      <div className="login-page-items column align-center">
        <div className='breadcrumb'>
          <button onClick={() => navigate(-3)} className="back-link back-link1 back-link2">
            Section &nbsp;&nbsp;&nbsp;<i className="fa-solid fa-angle-right font-gold size4"></i>
          </button>
          <button onClick={() => navigate(-2)} className="back-link back-link1 back-link2">
            Session &nbsp;&nbsp;&nbsp;<i className="fa-solid fa-angle-right font-gold size4"></i>
          </button>
          <button onClick={() => navigate(-1)} className="back-link back-link1 back-link2">
            Term &nbsp;&nbsp;&nbsp;<i className="fa-solid fa-angle-right font-gold size4"></i>
          </button>
          <button className="back-link back-link1 back-link2">
            Class
          </button>
        </div>
        <h2 className="manage-page-heading caps size4">Select Class</h2>
        <div className="scroll-fixed scroll-fixed1">
          <div className="class-list class-list-d scrollable class-items">
            {loading ? (
              <p className="loading-text male-female-stat">Loading classes...</p>
            ) : classes.length === 0 ? (
              <p className="empty-text male-female-stat">No classes found for this selection.</p>
            ) : (
              classes.map(cls => (
                <div key={cls.id}>
                  <RouterLink
                    to={`/archives/${sectionId}/${sessionId}/${termId}/${cls.id}`}
                    className="class-item class-item1 class-item1-d"
                  >
                    {cls.name}
                  </RouterLink>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ArchiveClasses;
